@if (params.data) {
    <div class="d-flex justify-content-end align-items-end">
        @for (action of params.actionItems; track action) {
            <div>
                <ng-template #actionButton>
                    <button
                        [nbSpinner]="action.isLoading"
                        [disabled]="action.isDisabled || action.isLoading"
                        [classList]="action.classList"
                        [hidden]="action.isHidden"
                        nbButton
                        [nbTooltip]="action.text"
                        [nbTooltipDisabled]="action.isLoading"
                        nbTooltipPlacement="bottom"
                        size="small"
                        (click)="handleAction(action, $event)">
                        <nb-icon
                            [icon]="action.icon"
                            [pack]="action.iconPack ?? 'eva'"
                            [status]="action.status || 'basic'"></nb-icon>
                    </button>
                </ng-template>
                @if (!action.dropdown && !params?.context?.menu) {
                    <ng-container *ngTemplateOutlet="actionButton"></ng-container>
                }
                @if (action.dropdown && params?.context?.menu) {
                    <kno2-split-button
                        size="small"
                        [classList]="action.classList"
                        [hidden]="action.isHidden"
                        [nbTooltip]="action.text"
                        [status]="action.status || 'basic'"
                        [menu]="{ tag: params?.context?.menu?.tag, items: itemsByAction[action.type] }"
                        [menuClickCallback]="handleMenuItemClick">
                        <ng-container *ngTemplateOutlet="actionButton"></ng-container>
                    </kno2-split-button>
                }
                @if (action.isHidden && action.altText) {
                    <span>{{ action.altText }}</span>
                }
            </div>
        }
    </div>
}
